__turbopack_context__.v({
  "description": "_-module__v6f0GG__description",
});
